import React from "react";
import { C } from "../../lib/colors.js";

/** Past-tint div + future-fade gradient backdrop for timeline/TSD lanes.
 *  Renders two absolutely-positioned overlay divs inside the parent container:
 *  - a solid past-tint covering [0, todayX)
 *  - a future-fade gradient covering [todayX, fadeEndX) that transitions to transparent
 */
export default function TimelineBackdrop({ todayX, vw, fadeStartX, fadeEndX }) {
  return (
    <>
      {todayX > 0 && (
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: Math.min(todayX, vw),
            height: "100%",
            // The neutral `past` token in every theme: a subtle shift, not a band.
            background: C.past,
            pointerEvents: "none",
          }}
        />
      )}
      {todayX < vw &&
        (() => {
          const startX = Math.max(0, todayX);
          const w = vw - startX;
          if (w <= 0) return null;
          const s1 = Math.max(0, Math.min(100, ((fadeStartX - startX) / w) * 100));
          const s2 = Math.max(0, Math.min(100, ((fadeEndX - startX) / w) * 100));
          const bg = `linear-gradient(to right, ${C.future} 0%, ${C.future} ${s1}%, transparent ${s2}%, transparent 100%)`;
          return (
            <div
              style={{
                position: "absolute",
                left: startX,
                top: 0,
                width: w,
                height: "100%",
                background: bg,
                opacity: 1,
                pointerEvents: "none",
              }}
            />
          );
        })()}
    </>
  );
}
